// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__DjVVZ","header":"style__header__sMO7t","content":"style__content__gOay6"};